import { render, staticRenderFns } from "./my_point.vue?vue&type=template&id=09396f70&scoped=true"
import script from "./my_point.vue?vue&type=script&lang=js"
export * from "./my_point.vue?vue&type=script&lang=js"
import style0 from "./my_point.vue?vue&type=style&index=0&id=09396f70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09396f70",
  null
  
)

export default component.exports